import React, { Component } from "react";
import "antd/dist/antd.css";
import { Row, Col, Table, Tag, Card, Input, Select, Button } from "antd";
import { Link } from "react-router-dom";
import AppConfigs from "../../Config/AppConfig";
import { list } from "../../api/Apis";
import moment from "moment";
import { showTotal, ordersSort } from "../commonFunctions";
import NumberFormat from "react-number-format";
import ResizableAntdTable from "resizable-antd-table";
import DownloadCsv from "../../Components/DownloadCsv";

const Search = Input.Search;
const { Option } = Select;

class StonesOrders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadsList: [],
      defaultStatus: "",
      totalOrdersList: [],
      oraganizationsData: [],
      dataLoadingStatus: true,
      userDetails: JSON.parse(localStorage.getItem("userDetails")),
    };
  }
  componentDidMount() {
    let orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
    if (orgDetails.userProfile !== "SCU") {
      if (orgDetails.approvalStatus === "D") {
        this.props.history.push("/carrier_app/review");
      } else if (!orgDetails["customerDocuments"]) {
        this.props.history.push("/app/customerdocumentation");
      } else if (!orgDetails["customerLocations"]) {
        this.props.history.push("/app/customerlocations");
      } else if (!orgDetails["productsSelected"]) {
        this.props.history.push("/app/customerProducts");
      } else if (
        (this.state.userDetails["userProfile"] === "SCU" ||
          this.state.userDetails["userProfile"] === "CU") &&
        !orgDetails["isActive"]
      ) {
        this.props.history.push("/carrier_app/review");
      } else if (!orgDetails["isActive"]) {
        // this.props.history.push('/app/stones');
        this.props.history.push("export");
      }
    }
    if (!this.state.userDetails["recordStatus"]) {
      this.props.history.push("/carrier_app/review");
    }
    let query = {
      customerId: orgDetails["id"],
    };
    list(AppConfigs["entityNames"]["leads"], query).then((result) => {
      if (result.success) {
        let finalResult = result.data;
        if (this.state.userDetails.userProfile !== "CU") {
          finalResult = result.data.filter(
            (item) =>
              this.state.userDetails.locations &&
              this.state.userDetails.locations.includes(
                item.cartItems[0]?.locationName
              )
          );
        }
        let loadList = finalResult.sort((a, b) =>
          parseInt(a["orderId"]) < parseInt(b["orderId"]) ? 1 : -1
        );

        this.setState({
          loadsList: loadList,
          totalOrdersList: loadList,
          dataLoadingStatus: false,
        });
        console.log(this.state.loadsList);
      } else {
        this.setState({
          dataLoadingStatus: false,
        });
        console.log(result.errors);
      }
    });
  }

  searchData = (event, searchType) => {
    console.log(event, searchType);
    let searcingValue = searchType === "text" ? event.target.value : event;
    let totalOrdersList = [];
    if (searcingValue.length > 0) {
      searcingValue = searcingValue.toLowerCase();
      if (searchType === "text") {
        this.setState({
          defaultStatus: "",
        });
        // totalOrdersList = this.state.totalOrdersList.filter((load) => load.orderId.toString() === searcingValue || load.customerName.toLowerCase().indexOf(searcingValue) > -1 || ("productName" in load && load.productName.toLowerCase().indexOf(searcingValue) > -1) || ("carrierDetails" in load && load.carrierDetails.carrierName.toLowerCase().indexOf(searcingValue) > -1) || ("poNumber" in load && load.poNumber.toLowerCase().indexOf(searcingValue) > -1))
        totalOrdersList = this.state.totalOrdersList.filter(
          (load) =>
            load.orderId.toString() === searcingValue ||
            load.customerName.toLowerCase().indexOf(searcingValue) > -1 ||
            ("productName" in load &&
              load.productName.toLowerCase().indexOf(searcingValue) > -1) ||
            ("poNumber" in load &&
              load.poNumber.toLowerCase().indexOf(searcingValue) > -1) ||
            (load.orderStatus === "AC" &&
              load.orderStatus === "I" &&
              load.orderStatus === "D" &&
              "carrierDetails" in load &&
              load.carrierDetails.carrierName
                .toLowerCase()
                .indexOf(searcingValue) > -1)
        );
      } else {
        if (searcingValue === "d") {
          totalOrdersList = this.state.totalOrdersList.filter(
            (load) => load.orderStatus.toLowerCase() === searcingValue
          );
        } else {
          totalOrdersList = this.state.totalOrdersList.filter(
            (load) =>
              load.orderStatus.toLowerCase() !== "r" &&
              load.orderStatus.toLowerCase() !== "d"
          );
        }
        this.setState({
          defaultStatus: searcingValue,
        });
      }
    } else {
      totalOrdersList = this.state.totalOrdersList;
      this.setState({
        defaultStatus: "",
      });
    }
    this.setState({
      loadsList: totalOrdersList,
    });
  };

  render() {
    const columns = [
      {
        title: <div style={{ color: "gray" }}>Order#</div>,
        dataIndex: "orderId",
        key: "orderId",
        // sorter: true,
        render: (id) => <div style={{ color: "black" }}>{id}</div>,
      },
      {
        title: <div style={{ color: "gray" }}>Sub Order#</div>,
        dataIndex: "subOrderId",
        key: "subOrderId",
        // sorter: true,
        render: (subOrderId) => (
          <div style={{ color: "black" }}>{subOrderId}</div>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Date & Time ordered</div>,
        dataIndex: "createdAt",
        key: "createdAt",
        // sorter: true,
        render: (dateordered, record) => (
          <span>
            <div style={{ color: "black" }}>
              {moment(dateordered).format("MM/DD/YYYY")}
            </div>
            <div className="subtext" style={{ color: "grey" }}>
              {moment(dateordered).format("hh:mm A")}
            </div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>PO#</div>,
        dataIndex: "poNumber",
        key: "poNumber",
        // sorter: true,
        render: (poNumber) => (
          <span>
            <div style={{ color: "black" }}>{poNumber}</div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Product Name</div>,
        dataIndex: "productName",
        key: "productName",
        // sorter: true,
        render: (productName) => (
          <span>
            <div style={{ color: "black" }}>{productName}</div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "grey" }}>Location</div>,
        dataIndex: "location",
        key: "location",
        width: "150px",
        render: (location, record) => (
          <span>
            <div style={{ color: "black" }}>
              {record["cartItems"][0]["locationName"]}
            </div>
            <div className="subtext" style={{ color: "grey" }}>
              {record["cartItems"][0]["address"] &&
              record["cartItems"][0]["address"].split(",").length > 0
                ? record["cartItems"][0]["address"].split(",")[1] +
                  ", " +
                  record["cartItems"][0]["address"].split(",")[2]
                : record.address}
            </div>
            {/* <div style={{ color: 'black' }}>{record["cartItems"][0]["locationName"]}</div> */}
            {/* <div style={{ color: 'black' }}>{record["cartItems"][0]["address"].split(",").length > 0 ? record["cartItems"][0]["address"].split(",")[1]+", "+record["cartItems"][0]["address"].split(",")[2] : record.address}</div> */}
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Price</div>,
        dataIndex: "totalAmt",
        key: "totalAmt",
        // sorter: true,
        render: (totalAmt) => (
          <span>
            <div style={{ color: "black" }}>
              <NumberFormat
                value={parseFloat(totalAmt).toFixed(2)}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
              />
            </div>
          </span>
        ),
      },
      // {
      //     title: <div style={{color: 'gray'}}>Quantity</div>,
      //     dataIndex: 'quantity',
      //     key: 'quantity',
      //     render: (quantity) => (
      //         <span>
      //             <div style={{color: "black"}}>{quantity}</div>
      //         </span>
      //     ),
      // },
      // {
      //     title: <div style={{color: 'gray'}}>Type of truck</div>,
      //     dataIndex: 'truck',
      //     key: 'truck',
      //     render: (truck, record) => (
      //         <span>
      //             <div style={{color: "black"}}>{truck}</div>
      //             <div className='subtext' style={{color: "grey"}}></div>
      //         </span>
      //     ),
      // },
      {
        title: <div style={{ color: "gray" }}>Requested Delivery Date</div>,
        dataIndex: "deliveryReqDate",
        key: "deliveryReqDate",
        // sorter: true,
        render: (deliverydaterequested, record) => (
          <span>
            <div style={{ color: "black" }}>{deliverydaterequested}</div>
            <div className="subtext" style={{ color: "grey" }}>
              {record.deliveryReqTime}
            </div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Carrier</div>,
        dataIndex: "assignCarrier",
        key: "assignCarrier",
        // sorter: true,
        render: (assignCarrier, record) => (
          <span>
            {assignCarrier && (
              <div style={{ color: "black" }}>
                {record["carrierDetails"]["carrierName"]}
              </div>
            )}
            {/* <div style={{color: "black"}}>{carrier}</div>
                        <div className='subtext' style={{color: "grey"}}>{record.carrierernumber}</div> */}
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Status</div>,
        key: "orderStatus",
        dataIndex: "orderStatus",
        // sorter: true,
        render: (tag, record) => (
          <div className="customer_orders">
            <Link
              to={"/app/orders/orderdetails/" + record["id"]}
              className="status_tag"
            >
              {/* <Tag color={tag === "N" ? "red" : tag === "P" ? 'orange' : tag === "PC" ? 'geekblue' : tag === "AC" ? "yellow":"green"} key={tag}>
                            {tag === "N" ? "Order Placed" : tag === "P" ? "In Progress" : tag === "D" ? "Delivered" : tag === "PC" ? "Order Processed" : "Assigned to carrier"}
                        </Tag> */}
              <Tag
                color={AppConfigs["STATUS_COLORS"][tag]}
                style={{
                  color: "black",
                  height: "27px",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                {AppConfigs["DISPLAY_LEAD_STATUS"]["customer"][tag]}
              </Tag>
            </Link>
          </div>
        ),
      },
    ];
    return (
      <div>
        <div className="site-card-border-less-wrapper">
          <h1 className="headings"> All Orders </h1>
          <Row className="search-options">
            <Col xs={24} sm={24} md={8} lg={4}>
              <Search
                className="products-search"
                size="large"
                placeholder="Search"
                onChange={(event) => this.searchData(event, "text")}
              />
            </Col>
            <Col xs={24} sm={24} md={8} lg={4}>
              <div className="vl" />
            </Col>
            <Col xs={24} sm={12} md={8} lg={4}>
              <div className="loads-select">
                <Select
                  onChange={(event) => this.searchData(event, "status")}
                  defaultValue="All Status"
                  value={this.state.defaultStatus}
                  notFoundContent={"Not found?!"}
                  style={{ width: 140 }}
                >
                  <Option key="All" value="">
                    All Status
                  </Option>
                  <Option key="a" value="a">
                    Open Orders
                  </Option>
                  <Option key="d" value="d">
                    Closed Orders
                  </Option>
                </Select>
              </div>
            </Col>
          </Row>
          <Row className="order-table">
            <Card>
              <ResizableAntdTable
                bordered={true}
                columns={columns}
                dataSource={this.state.loadsList}
                loading={this.state.dataLoadingStatus}
                rowKey={(record) => record.id}
                onChange={(pagination, filters, sorter) => {
                  this.setState({
                    loadsList: ordersSort(
                      pagination,
                      filters,
                      sorter,
                      this.state.loadsList
                    ),
                  });
                }}
                pagination={{
                  defaultPageSize: 10,
                  showSizeChanger: true,
                  pageSizeOptions: ["10", "25", "50", "100"],
                  total: this.state.loadsList.length,
                  showTotal: showTotal,
                }}
                onRow={(r) => ({
                  onClick: () =>
                    (window.location = "/app/orders/orderdetails/" + r.id),
                  style: { cursor: "pointer" },
                })}
                style={{ overflowX: "scroll" }}
              />
          <Button>
            <DownloadCsv
              data={this.state.loadsList}
              columns={columns}
              filename={'Orders'}
            />
          </Button>
            </Card>
          </Row>
        </div>
      </div>
    );
  }
}
export default StonesOrders;
